import moment from "moment";

const archivePageId = postType => {
  let pageId = "";
  switch (postType) {
    case "post":
      pageId = window.WPVUE.post_page;
      break;
    case "events":
      pageId = window.WPVUE.options.archives.events_archives;
      break;
    case "help":
      pageId = window.WPVUE.options.archives.help_archives;
      break;
    case "sponsors":
      pageId = window.WPVUE.options.archives.sponsors_page;
      break;
    case "inspirasjon":
      pageId = window.WPVUE.options.archives.inspirasjon_page;
        break;
    case "aktiviteter":
      pageId = window.WPVUE.options.archives.aktiviteter_page;
        break;
    case "video":
      pageId = window.WPVUE.options.archives.video_page;
      break;
  }
  if (!pageId) window.WPVUE.post_page;
  return Number(pageId);
};

const setCookie = (cookieName, cvalue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cookieName + "=" + cvalue + ";" + expires + ";path=/";
};
const getCookie = cookieName => {
  var name = cookieName + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

/**
 * Remembered content passwords ("section" passwords): every successful
 * password is stored for 30 days and auto-retried on other locked posts,
 * so one shared password unlocks a whole section without retyping.
 */
const PASSWORDS_KEY = "tb_pp_passwords";
const PASSWORD_TTL_DAYS = 30;

const getStoredPasswords = () => {
  try {
    const now = new Date().getTime();
    const list = JSON.parse(localStorage.getItem(PASSWORDS_KEY)) || [];
    return list.filter(it => it && it.p && it.exp > now).map(it => it.p);
  } catch (e) {
    return [];
  }
};

const rememberPassword = pass => {
  try {
    const now = new Date().getTime();
    const list = (JSON.parse(localStorage.getItem(PASSWORDS_KEY)) || []).filter(
      it => it && it.p && it.p !== pass && it.exp > now
    );
    // most-recently-successful first
    list.unshift({
      p: pass,
      exp: now + PASSWORD_TTL_DAYS * 24 * 60 * 60 * 1000
    });
    localStorage.setItem(PASSWORDS_KEY, JSON.stringify(list));
  } catch (e) {
    // storage unavailable (private mode): degrade to per-page prompting
  }
};

const isExternal = url => {
  if (!url) return;
  const checkDomain = function(url) {
    if (url.indexOf("//") === 0) {
      url = location.protocol + url;
    }
    return url
      .toLowerCase()
      .replace(/([a-z])?:\/\//, "$1")
      .split("/")[0];
  };
  return (
    (url.indexOf(":") > -1 || url.indexOf("//") > -1) &&
    checkDomain(location.href) !== checkDomain(url)
  );
};

const isPastEvent = eventPost => {
  const now = Number(
    moment()
      .startOf("day")
      .format("x")
  );
  const startDate = Number(moment(eventPost.acf.start_date).format("x"));
  const endDate = eventPost.acf.end_date
    ? Number(moment(eventPost.acf.end_date).format("x"))
    : eventPost.startDate;
  let isPast = false;
  if (startDate < endDate) {
    isPast = endDate && endDate >= now;
  } else {
    isPast = startDate && startDate >= now;
  }
  return !isPast;
};

export {
  archivePageId,
  setCookie,
  getCookie,
  isExternal,
  isPastEvent,
  getStoredPasswords,
  rememberPassword
};
